import EanaAppIcon from './eana-app-icon';
export default EanaAppIcon;
